// IMAGES
import image1 from "./images/1.png";
import image2 from "./images/2.png";
import image3 from "./images/3.png";
import image4 from "./images/4.png";
import image5 from "./images/5.png";
import image6 from "./images/6.png";
import image7 from "./images/7.png";
import image8 from "./images/8.png";
import image9 from "./images/9.png";
import image10 from "./images/10.png";
import image11 from "./images/11.png";
import image12 from "./images/12.png";
import image13 from "./images/13.png";
import image14 from "./images/14.png";
import image15 from "./images/15.png";
import image16 from "./images/16.png";
import image17 from "./images/17.png";
import image18 from "./images/18.png";
import image19 from "./images/19.png";
import image20 from "./images/20.png";
import image21 from "./images/21.png";
import image22 from "./images/22.png";
import image23 from "./images/23.png";
import image24 from "./images/24.png";
import image25 from "./images/25.png";

// SONGS
import song1 from "./mp3/Wham-LastChristmas.mp3";
import song2 from "./mp3/OlentzeroTxirriMirrietaTxiribiton.mp3";
import song3 from "./mp3/ArianaGrande-LastChristmas.mp3";
import song4 from "./mp3/RockinAroundTheChristmasTree.mp3";
import song5 from "./mp3/HatorHator.mp3";
import song6 from "./mp3/LaNuitChoristes.mp3";
import song7 from "./mp3/KeenV.mp3";
import song8 from "./mp3/Rudolph.mp3";
import song9 from "./mp3/ViveLeVent.mp3";
import song10 from "./mp3/JoungoulBell.mp3";
import song11 from "./mp3/AiOlentzero.mp3";
import song12 from "./mp3/TinoRossi.mp3";
import song13 from "./mp3/FelizNavidad.mp3";
import song14 from "./mp3/PerryComo.mp3";
import song15 from "./mp3/JingleBellRock.mp3";
import song16 from "./mp3/NoelBlanc.mp3";
import song17 from "./mp3/NoelHardstyle.mp3";
import song18 from "./mp3/CelKilt.mp3";
import song19 from "./mp3/OlentzeroEitb.mp3";
import song20 from "./mp3/Mariachis.mp3";
import song21 from "./mp3/Villancico.mp3";
import song22 from "./mp3/WhiteChristmas.mp3";
import song23 from "./mp3/Queen.mp3";
import song24 from "./mp3/ChuckBerry.mp3";
import song25 from "./mp3/MariahCarey.mp3";

// LOTTIE
import lottie1 from "./lotties/1.json";
import lottie2 from "./lotties/2.json";
import lottie3 from "./lotties/3.json";
import lottie4 from "./lotties/4.json";
import lottie5 from "./lotties/5.json";
import lottie6 from "./lotties/6.json";
import lottie7 from "./lotties/7.json";
import lottie8 from "./lotties/8.json";
import lottie9 from "./lotties/9.json";
import lottie10 from "./lotties/10.json";
import lottie11 from "./lotties/11.json";
import lottie12 from "./lotties/12.json";
import lottie13 from "./lotties/13.json";
import lottie14 from "./lotties/14.json";
import lottie15 from "./lotties/15.json";
import lottie16 from "./lotties/16.json";
import lottie17 from "./lotties/17.json";
import lottie18 from "./lotties/18.json";
import lottie19 from "./lotties/19.json";
import lottie20 from "./lotties/20.json";
import lottie21 from "./lotties/21.json";
import lottie22 from "./lotties/22.json";
import lottie23 from "./lotties/23.json";
import lottie24 from "./lotties/24.json";
import lottie25 from "./lotties/25.json";

const calendar = [
  {
    number: "1",
    image: image1,
    lottie: lottie1,
    url: song1,
  },
  {
    number: "2",
    image: image2,
    lottie: lottie2,
    url: song2,
  },
  {
    number: "3",
    image: image3,
    lottie: lottie3,
    url: song3,
  },
  {
    number: "4",
    image: image4,
    lottie: lottie4,
    url: song4,
  },
  {
    number: "5",
    image: image5,
    lottie: lottie5,
    url: song5,
  },
  {
    number: "6",
    image: image6,
    lottie: lottie6,
    url: song6,
  },
  {
    number: "7",
    image: image7,
    lottie: lottie7,
    url: song7,
  },
  {
    number: "8",
    image: image8,
    lottie: lottie8,
    url: song8,
  },
  {
    number: "9",
    image: image9,
    lottie: lottie9,
    url: song9,
  },
  {
    number: "10",
    image: image10,
    lottie: lottie10,
    url: song10,
  },
  {
    number: "11",
    image: image11,
    lottie: lottie11,
    url: song11,
  },
  {
    number: "12",
    image: image12,
    lottie: lottie12,
    url: song12,
  },
  {
    number: "13",
    image: image13,
    lottie: lottie13,
    url: song13,
  },
  {
    number: "14",
    image: image14,
    lottie: lottie14,
    url: song14,
  },
  {
    number: "15",
    image: image15,
    lottie: lottie15,
    url: song15,
  },
  {
    number: "16",
    image: image16,
    lottie: lottie16,
    url: song16,
  },
  {
    number: "17",
    image: image17,
    lottie: lottie17,
    url: song17,
  },
  {
    number: "18",
    image: image18,
    lottie: lottie19,
    url: song18,
  },
  {
    number: "19",
    image: image19,
    lottie: lottie18,
    url: song19,
  },
  {
    number: "20",
    image: image20,
    lottie: lottie20,
    url: song20,
  },
  {
    number: "21",
    image: image21,
    lottie: lottie21,
    url: song21,
  },
  {
    number: "22",
    image: image22,
    lottie: lottie22,
    url: song22,
  },
  {
    number: "23",
    image: image23,
    lottie: lottie23,
    url: song23,
  },
  {
    number: "24",
    image: image24,
    lottie: lottie24,
    url: song24,
  },
  {
    number: "25",
    image: image25,
    lottie: lottie25,
    url: song25,
  },
];

export default calendar;
